import React from "react";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import { hasRoutePermission } from "shared/utils";

const PermissionButton = ({ role, route, permission, ...props }) => {
  const { dispatch, ...rest } = props;
  let allow = hasRoutePermission(route, role, permission);

  return (
    <Button
      variant="contained"
      className="shadow-none"
      color="primary"
      disabled={allow ? false : true}
      {...rest}
    >
      {rest.children}
    </Button>
  ) ;
};

const mapStateToProps = ({ role }) => ({
  role,
});

export default connect(mapStateToProps)(PermissionButton);
